import classNames from 'classnames';

import './buttons-group-labelled.scss';
import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
export type ButtonsGroupLabelledProps<T extends string> = {
  id: string;
  label: string;
  options: T[];
  value: Nullable<T>;
  translationPrefix?: string;
  translationKeyMapper?: (item: T) => string;
  isReadOnly?: boolean;
  isInvalid?: boolean;
  isHighlighted?: boolean;
  isNullable?: boolean;
  onValueChanged: (value: readonly T[]) => void;
};

export function ButtonsGroupLabelled<T extends string>({
  id,
  label,
  options,
  value,
  translationPrefix,
  translationKeyMapper,
  isReadOnly = false,
  isInvalid = false,
  isHighlighted = false,
  isNullable = false,
  onValueChanged,
}: ButtonsGroupLabelledProps<T>) {
  return (
    <div
      className={classNames('input-group', 'card', 'card-bordering-primary', 'bg-lvl1', 'buttons-group-labelled', {
        'border-bottom border-warning': isInvalid,
        'border-bottom border-info': isHighlighted,
      })}
    >
      <div className="d-flex align-items-center px-12px px-xxl-3 py-xxl-12px label">
        <label htmlFor={id} className="text-secondary fs-5">
          {label}
        </label>
      </div>
      <ButtonsGroup
        id={id}
        items={options}
        selectedItems={value}
        onSelectionChanged={onValueChanged}
        isRadio
        className="px-12px"
        translationPrefix={translationPrefix}
        translationKey={translationKeyMapper}
        isReadonly={isReadOnly}
        blurOnClick={isNullable}
      />
    </div>
  );
}
